import useAppSelector from "@/core/helpers/useAppSelector";
import { vehicleSelector } from "@/domains/gasStation/slice";
import GasStationVehicleInfo from "@/domains/gasStation/components/GasStationVehicleInfo.tsx";

export default function GasStationVehicleInfoContainer() {
  const vehicle = useAppSelector(vehicleSelector);

  return <GasStationVehicleInfo {...vehicle} />;
}
